import React, { useState, useEffect } from "react";
import { PermissionWrapper, Icon } from "components";
import { clipboardIcon } from "assets";

// Універсальний компонент редагування комірки
const EditableTableCell = ({
  item,
  field,
  editing,
  onDoubleClick,
  onKeyDown,
  setEditing,
  requiredPermission,
  inputType = "text",
  step,
  placeholder = "",
  isSecret = false,
  isCopyable = false,
}) => {
  // Визначаємо активний стан редагування
  const isEditing = editing.id === item.id && editing.field === field;
  const value = item[field];
  const [isCopied, setIsCopied] = useState(false);

  // Очищення таймера при демонтуванні компонента
  useEffect(() => {
    let timer;
    if (isCopied) {
      timer = setTimeout(() => setIsCopied(false), 1500);
    }
    return () => clearTimeout(timer);
  }, [isCopied]);

  const displayValue =
    isSecret && value && !isEditing ? `${String(value).slice(0, 6)}******` : value;

  // Обробник натискання кнопки копіювання
  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      setIsCopied(true);
    } catch (err) {
      console.error("Не вдалося скопіювати текст: ", err);
    }
  };

  // Генеруємо вміст комірки
  const cellContent = (
    <div className="editable-cell">
      <span>{displayValue}</span>
      {isCopyable && value && !isEditing && (
        <button onClick={handleCopy} title="Скопіювати" className="copy-btn">
          <div className={`icon-bg-circle ${isCopied ? "is-copied" : ""}`}>
            <Icon src={clipboardIcon} className="copy-icon" />
          </div>
        </button>
      )}
    </div>
  );

  return (
    <PermissionWrapper
      requiredPermission={requiredPermission}
      fallback={<td>{cellContent}</td>}
    >
      <td
        className="clickable"
        onDoubleClick={() => onDoubleClick(item.id, field, value)}
      >
        {isEditing ? (
          <input
            type={inputType}
            step={inputType === "number" ? step : undefined}
            autoFocus
            placeholder={placeholder}
            value={editing.value}
            onChange={(e) => setEditing((ed) => ({ ...ed, value: e.target.value }))}
            onKeyDown={onKeyDown}
            onBlur={() => setEditing({ id: null, field: null, value: "" })}
          />
        ) : (
          cellContent
        )}
      </td>
    </PermissionWrapper>
  );
};

export default EditableTableCell;
